import { Box, Typography } from "@mui/material";
import { toast } from "react-toastify";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import React from "react";
import CustomColor from "../../utils/overrides/color";

export function toastSuccess(mess: string, title?: string) {
  toast(<MsgSuccess mess={mess} title={title} />, {
    autoClose: 1000,
    position: "bottom-right",
    pauseOnHover: true,
    hideProgressBar: true,
    closeOnClick: true,
    closeButton: false,
  });
}
export function toastError(mess: string, title?: string) {
  toast(<MsgError mess={mess} title={title} />, {
    autoClose: 1000,
    position: "bottom-right",
    pauseOnHover: true,
    hideProgressBar: true,
    closeOnClick: true,
    closeButton: false,
  });
}

interface IProps {
  mess: string;
  title?: string;
}
const MsgSuccess = (props: IProps) => (
  <Box
    sx={{
      display: "flex",
      background: "#FDFDFD",
      alignItems: "center",
      maxWidth: "90%",
      "@media (max-width: 600px)": {
        background: "none",
      },
    }}
  >
    <div
      style={{
        width: 27,
        display: "flex",
        alignItems: "center",
      }}
    >
      <CheckCircleIcon
        sx={{ fill: "#12B76A" }}
        style={{ width: 27, height: 27 }}
      />
    </div>
    <Box
      sx={{
        marginLeft: "20px",
        "@media (max-width: 600px)": {
          marginLeft: "8px",
        },
      }}
    >
      {props.title && (
        <Typography
          variant="body1"
          sx={{
            fontWeight: 700,
            color: "#12B76A",
            mb: "4px",
          }}
        >
          {props.title}
        </Typography>
      )}
      <Typography
        variant="body2"
        sx={{
          color: "#919AA4",
          "@media (max-width: 600px)": {
            color: "#FDFDFD",
            fontWeight: 400,
            fontFamily: "Inter, sans-serif",
          },
        }}
      >
        {props.mess}
      </Typography>
    </Box>
  </Box>
);
const MsgError = (props: IProps) => (
  <div
    style={{
      display: "flex",
      background: "#FDFDFD",
      maxWidth: "90%",
    }}
  >
    <div
      style={{
        width: 27,
        display: "flex",
        alignItems: "center",
      }}
    >
      <CancelIcon sx={{ fill: "#D92D20" }} style={{ width: 27, height: 27 }} />
    </div>
    <div style={{ marginLeft: "20px" }}>
      {props.title && (
        <Typography
          variant="body1"
          sx={{ fontWeight: 700, color: "#D92D20", mb: "4px" }}
        >
          {props.title}
        </Typography>
      )}
      <Typography variant="body2" sx={{ color: "#919AA4" }}>
        {props.mess}
      </Typography>
    </div>
  </div>
);
